import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChange,
  ViewChild,
} from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

import intlTelInput from 'intl-tel-input';

import { TranslatePipe } from '@recruitee/i18n';

import { RtInput } from '../../utils/rt-input';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'rt-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.less'],
  standalone: true,
  imports: [InputComponent, TranslatePipe],
})
export class RtPhoneInputComponent extends RtInput<string> implements OnInit {
  @Input() public countryCode: string;
  @Input() public placeholder: string;
  @Input() public invalid: boolean;
  @Input() public autoFocus: boolean = false;

  @Output() public valueChange: EventEmitter<string> = new EventEmitter();
  @Output() public blur: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputComponent', { static: true }) public inputComponent: InputComponent;

  public intl: any;

  public ngOnChanges({ countryCode }: { countryCode: SimpleChange }): void {
    if (this.intl && countryCode) this.intl.setCountry(countryCode.currentValue);
  }

  public ngOnInit(): void {
    this.intl = intlTelInput(this.inputComponent.input.nativeElement, {
      initialCountry: this.countryCode || 'gb',
      nationalMode: false,
      formatOnDisplay: false,
      preferredCountries: ['nl', 'gb', 'de', 'us'],
      autoPlaceholder: undefined,
      autoHideDialCode: false,
      utilsScript: 'assets/scripts/utils.js',
    });

    if (this.ngControl?.value) this.setExistedNumber(this.ngControl.value);

    this.intl.promise.then(() => {
      if (!this.ngControl) return;
      this.ngControl.control?.addValidators([this.phoneNumberValidator()]);
      this.ngControl.control?.updateValueAndValidity();
    });

    this.changeCountry();
  }

  private setExistedNumber(number: string): void {
    this.intl.setNumber(number);
    this.ngControl?.control?.markAsTouched();
  }

  private phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl) =>
      this.intl.isValidNumber() ? null : { invalidNumber: true };
  }

  private changeCountry(): void {
    this.inputComponent.input.nativeElement.addEventListener('close:countrydropdown', () => {
      const insertedNumber = this.intl.getNumber();
      if (this.ngControl?.value === insertedNumber) return;
      this.ngControl?.control?.setValue(insertedNumber);
    });
  }
}
